import { write } from "./write"

export const swProject = {
  write,
}
